import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import ReactTable from 'react-table'
import "react-table/react-table.css";

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';



class QuotationClosed extends Component {

    constructor(){
        super();
        
        this.view = this.view.bind(this)
        this.remove = this.remove.bind(this)
        this.state = {
            userId:"",
            user :{},
            quotation: {}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        });   
    }


    componentDidMount(){
        let quotation = ref.child("Quotation").orderByChild('status').equalTo('Deal');
            quotation.on("value", function(snap){
                this.setState({
                    quotation : snap.val()
                })
            }.bind(this))
    }

    view(index){
        window.location.assign("/quotation/"+index+"/show")
    }

    remove(index){
        if(window.confirm("Are you sure you want to delete this closed quotation")===true){
            ref.child("Quotation").child(index).remove();
        }
    }

    render() {
        var x = [];
        this.state.quotation &&
        Object.keys(this.state.quotation).map(key => {
            let list = this.state.quotation[key]
                list.id = key
            x.push(list)
            }) 
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Closed Deal Quotation" />
                            <div className="block">
                               <ReactTable
                                    data={x}
                                    columns={[
                                        {
                                            Header: "Quotation Number",
                                            accessor : "id"
                                        },
                                        {
                                            Header: "Customer Name",
                                            accessor : "customer.name"
                                        },
                                        {
                                            Header: "Address",
                                            accessor : "customer.location"
                                        },
                                        {
                                            Header: "Sales Representative",
                                            accessor : "customer.representative"
                                        },
                                        {
                                            Header: "Status",
                                            accessor : "status"
                                        },
                                        {
                                            Header: 'Action',
                                            accessor : "id",
                                            Cell : row => (
                                                <span>
                                                <button onClick={()=>this.view(row.value)}><i className="fa fa-eye"></i></button>
                                                <button onClick={()=>this.remove(row.value)}><i className="fa fa-trash-o"></i></button>                                                
                                                </span>
                                            )
                                                                               
                                        }
                                    ]}
                                    
                                    filterable ={true}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />     
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default QuotationClosed;



// WEBPACK FOOTER //
// ./src/components/QuotationClosedAdmin.js